import { Job } from "@models/job.model";
import { httpRequest } from "../../http";
import { JobSerializer } from "@models/serializers/jobSerializer";

export interface PublishOptions {
  /** Campaigns Ops selected. Omitted publishes every ready campaign, as it always did. */
  launchIds?: number[];
  /** Sync to the network but land PAUSED, so going live is a second, deliberate action. */
  publishPaused?: boolean;
  /**
   * Audiences to re-upload in full, ignoring which members are already on the network
   * (MPN-1970). Staff only; the server refuses it for anyone else.
   */
  reuploadAudienceIds?: number[];
}

export class CommandPublishEngagement {
    async run(engagementId: number, options: PublishOptions = {}): Promise<Job> {
        const response = await httpRequest<any>(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/publish/`,
            {
                method: "POST",
                body: JSON.stringify({
                    launch_ids: options.launchIds ?? null,
                    publish_paused: options.publishPaused ?? false,
                    reupload_audience_ids: options.reuploadAudienceIds ?? null,
                }),
            }
        );
        return new JobSerializer().deserialize(response);
    }
}
